import React from "react";
import { useTranslation } from "react-i18next";
import { VolumeX } from "lucide-react";
import { usePhoneMuted } from "@/hooks/usePhoneMuted";

/* Avertissement persistant tant que le téléphone est en silencieux / vibreur :
   les alertes sonores (in-app et push) ne seront pas entendues. Natif seulement. */
export default function SilentModeBanner() {
  const { t } = useTranslation();
  const muted = usePhoneMuted();
  if (muted !== true) return null;
  return (
    <div className="mb-4 rounded-2xl border border-amber-400/60 bg-amber-50 p-4 flex items-start gap-3 animate-pulse" data-testid="silent-mode-banner">
      <VolumeX className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
      <div className="text-sm">
        <div className="font-semibold text-amber-900">{t("push.silentTitle")}</div>
        <p className="text-amber-800 mt-0.5">{t("push.silentText")}</p>
      </div>
    </div>
  );
}
